import { render } from "./ClientIndex.vue?vue&type=template&id=75d6ad2c&scoped=true"
import script from "./ClientIndex.vue?vue&type=script&lang=js"
export * from "./ClientIndex.vue?vue&type=script&lang=js"

import "./ClientIndex.vue?vue&type=style&index=0&id=75d6ad2c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d6ad2c"]])

export default __exports__